const translationEng = {
  //About us Translation
  'About Us': 'About Us',
  'SwapAround is a new social network for swapping. You can swap anything, your surpluses, items or services. Anything you can think of and responds to our categories.':
    'SwapAround is a new social network for swapping. You can swap anything, your surpluses, items or services. Anything you can think of and responds to our categories.',
  //FAQ Translation
  'How do I use SwapAround?': 'How do I use SwapAround?',
  'Do I necessarily have to ask only for surpluses for my Offers?':
    'Do I necessarily have to ask only for surpluses for my Offers?',
  'What are SwapAroud policies?': 'What are SwapAroud policies?',
  'What do I need to create a profile?': 'What do I need to create a profile?',
  'What kind of profile photo should I upload?':
    'What kind of profile photo should I upload?',
  'When will my Offers go online?': 'When will my Offers go online?',
  'What do I get for the membership I pay to SwapAround?':
    'What do I get for the membership I pay to SwapAround?',

  //1
  '<ol> <li>SwapAround has the easiest possible manipulation. Even elderly people can manage. The User signs to be either an &bdquo;I seek&ldquo; or an &bdquo;I Offer&ldquo; User. Everyone can be both and switch in their account between the profiles. Users can log in with an email address, Facebook account or Google account.</li> <li>You must fill all profile details, including a short introduction e.g. &ldquo;Ecology mined woman on maternity leave who likes to give new life to old things&rdquo;, &ldquo;Stay at home mother who welcomes every item for her household&rdquo; and upload a profile picture.</li> <li>As &bdquo;I Offer&ldquo; user, you create your Offer (plus icon on &bdquo;I Offer &lsquo;s&ldquo; profile) &ndash; it can be anything &ndash; things you don&rsquo;t need anymore, things you make and you welcome to swap them for other things, services you provide and want to swap them for other services or items. You have to upload a picture of your Offer, fill the description, write down for what you want to swap them, how many portions/items/seats you have available, date and time of availability and your Offer is online. If someone is interested in your Offer, you will get a notification either as a chat request or a direct Order. You can chat with the &bdquo;I seek&ldquo; User about an additional questions regarding your Offer.&nbsp;</li> <li>As a Guest you set filters &ndash; distance from the place where you are located at the moment, time, category of item you are seeking or use a key word search. Then SwapAround gives you matches with the Offers and you can start browsing.&nbsp;</li> <li>After Swap is due, you can rate under each profile, which builds trust in the community.</li> <li>When you see that a User on the other side is violating our Terms and Conditions, you can report them.</li> </ol>': 
  '<ol> <li>SwapAround h  as the easiest possible manipulation. Even elderly people can manage. The User signs to be either an &bdquo;I seek&ldquo; or an &bdquo;I Offer&ldquo; User. Everyone can be both and switch in their account between the profiles. Users can log in with an email address, Facebook account or Google account.</li> <li>You must fill all profile details, including a short introduction e.g. &ldquo;Ecology mined woman on maternity leave who likes to give new life to old things&rdquo;, &ldquo;Stay at home mother who welcomes every item for her household&rdquo; and upload a profile picture.</li> <li>As &bdquo;I Offer&ldquo; user, you create your Offer (plus icon on &bdquo;I Offer &lsquo;s&ldquo; profile) &ndash; it can be anything &ndash; things you don&rsquo;t need anymore, things you make and you welcome to swap them for other things, services you provide and want to swap them for other services or items. You have to upload a picture of your Offer, fill the description, write down for what you want to swap them, how many portions/items/seats you have available, date and time of availability and your Offer is online. If someone is interested in your Offer, you will get a notification either as a chat request or a direct Order. You can chat with the &bdquo;I seek&ldquo; User about an additional questions regarding your Offer.&nbsp;</li> <li>As a Guest you set filters &ndash; distance from the place where you are located at the moment, time, category of item you are seeking or use a key word search. Then SwapAround gives you matches with the Offers and you can start browsing.&nbsp;</li> <li>After Swap is due, you can rate under each profile, which builds trust in the community.</li> <li>When you see that a User on the other side is violating our Terms and Conditions, you can report them.</li> </ol>',

  //2
  '<p>Not at all. It is only about demand and supply. If people accept your Offers swapped for services or new items, it is totally up to you what you ask for. The only thing you can not ask for is money.</p>':
    '<p>Not at all. It is only about demand and supply. If people accept your Offers swapped for services or new items, it is totally up to you what you ask for. The only thing you can not ask for is money.</p>',
  //3
  '<p>SwapAround has a strict non-discrimination policy. SwapAround is at its core, an open community dedicated to bringing the world closer together by fostering meaningful, shared experiences among people from all parts of the world. Our community includes people from virtually every country on the globe. It is an incredibly diverse community, drawing together individuals of different cultures, values, and norms.<br />The SwapAround community is committed to building a world where people from every background feel welcome and respected. This commitment rests on two foundational principles that apply all to SwapAround Users inclusion and respect. Our shared commitment to these principles enables every User to feel welcome on SwapAround no matter who they are, where they come from, how they worship, or whom they love.</p>':
    '<p>SwapAround has a strict non-discrimination policy. SwapAround is at its core, an open community dedicated to bringing the world closer together by fostering meaningful, shared experiences among people from all parts of the world. Our community includes people from virtually every country on the globe. It is an incredibly diverse community, drawing together individuals of different cultures, values, and norms.<br />The SwapAround community is committed to building a world where people from every background feel welcome and respected. This commitment rests on two foundational principles that apply all to SwapAround Users inclusion and respect. Our shared commitment to these principles enables every User to feel welcome on SwapAround no matter who they are, where they come from, how they worship, or whom they love.</p>',
  //4
  '<p>Only a smartphone, tablet, laptop or a PC to use the Platform. Creating of the profile is doable only via MyCookAround platform and takes approximately 10 minutes.</p>':
    '<p>Only a smartphone, tablet, laptop or a PC to use the Platform. Creating of the profile is doable only via MyCookAround platform and takes approximately 10 minutes.</p>',
  //5
  '<p>It has to be a genuine photo of yourself.</p>':
    '<p>It has to be a genuine photo of yourself.</p>',
  //6
  '<p> Immediately. You don‘t have to wait for any approval. </p>':
    '<p> Immediately. You don‘t have to wait for any approval. </p>',
  //7
  '<p>A powerful online presence and technical support. SwapAround actively markets your Offers. A dedicated team verifies Users &sbquo; reviews, making sure they are legitimate. This gives you credibility and helps future swappers make the decision to stay with you. 24/7 support is here for you and your swappers.</p>':
    '<p>A powerful online presence and technical support. SwapAround actively markets your Offers. A dedicated team verifies Users &sbquo; reviews, making sure they are legitimate. This gives you credibility and helps future swappers make the decision to stay with you. 24/7 support is here for you and your swappers.</p>',

  //Profile translation
  SEARCH_FOR: 'Search for...',
  'Became i seek': `Become I seek`,
  'Became i offer': `Become I offer`,
  Seek: 'Seek',
  Offer: 'Offer',
  Profile: `Profile`,
  'Payment Card': `Payment Card`,
  Settings: `Settings`,
  Share: `Share`,
  'Bank Account': `Bank Account`,
  Logout: `Logout`,
  'Contact Support': `Contact Support`,
  'Contact Us': `Contact Us`,
  FAQ: 'FAQ',
  'Terms and Conditions': 'Terms and Conditions',
  'Edit Profile': `Edit Profile`,
  'My Account': 'My Account',
  'Push Notifications': `Push Notifications`,
  'Sign out': 'Sign out',
  'Current Orders': `Current Orders`,
  'Past Orders': `Past Orders`,
  'Newest First': 'Newest First',
  Oldest: 'Oldest',
  'Filter by': 'Filter by',
  'Have any question or need help?': 'Have any question or need help?',
  'Feel free to write us. We will answer you as soon as possible.': `Feel free to write us. We will answer you as soon as possible.`,
  Send: `Send`,
  'My Offer': 'My Offer',
  'User Reviews': 'User Reviews',
  'Meal Details': 'Meal Details',
  'Order Details': 'Order Details',
  'Cannot find offers': 'Cannot find offers',
  'Searching Offers around': 'Searching Offers around',
  Order: 'Swap',
  Save: 'Save',
  'Currently you have no past orders': 'Currently you have no past orders',
  'Currently you have no orders': 'Currently you have no orders',
  'Back to my orders': 'Back to my orders',
  'Waiting for Accept': 'Waiting for Accept',
  Refused: 'Refused',
  Ready: 'Ready',
  'Ready in': 'Ready in',
  ARRIVE_IN: 'Arrive in',
  'per item': 'per item',
  Quantity: 'Quantity',
  Available: 'Available',
  'I offers Details': 'I offers Details',
  'I seeks Details': 'I seeks Details',
  'Take away': 'Take away',
  'Eat with': 'Eat with',
  Both: 'Both',
  'Total Price': 'Total Price',
  'Your Payout': 'Your Payout',
  'i offer': 'i offer',
  'i seek': 'i seek',
  Cook: 'I offer',
  Guest: 'I seek',
  Cooks: 'I offer',
  Guests: 'I seek',
  'Currently the cooks have no added offer':
    'Currently the cooks have no added offer',
  'Report i offer': 'Report i offer',
  'Report i seek': 'Report i seek',
  Cancel: 'Cancel',
  'New Offer': 'New Offer',
  General: 'General',
  'Number of items available': 'Number of items available',
  'Price per portion/item': 'Price per portion/item',
  'Date and Time': 'Date and Time',
  CONSUMPTION_TYPE_MESSAGE:
    'Food is available for Eat with, which means the guest has to consume the food at the cooks place',
  NO_OFFER_LISTED: 'You have no offer listed yet',
  Done: 'Done',
  Category: 'Category',
  Select: 'Select',
  Name: 'Name',
  Description: 'Description',
  Restrictions: 'Restrictions',
  'Type of Consumption': 'Type of Consumption',
  TODAY: 'Today',
  YESTEDAY: 'Yesterday',
  RATE_YOUR_GUEST: 'Rate your Guest!',
  RATE_YOUR_COOK: 'Rate your Cook!',
  WRITE_A_NOTE: 'Write a note…',
  CHANGE_PASSWORD: 'Change Password',
  RESET_PASSWORD: 'Reset Password',
  RESET_YOUR_PASSWORD: 'Reset your password',
  RESET_PASSWORD_SUCCESSFUL: 'Your password has been updated successfully.',
  YOUR_EMAIL: `Your Email`,
  WRITE_MESSAGE: 'Write a message',
  DETAILS: 'Details',
  MEAL_NOT_EXISTS: 'offer does not exist',
  DELETE: 'Delete',
  DELETE_MESSAGE: 'Do you really want to delete this offer?',
  NO_REVIEWS: 'No reviews yet',
  USERNAME: 'Username',
  PHONE_NUMBER: 'Phone Number',
  STREET: 'Street',
  CITY: 'City',
  NOTE: 'Note',
  ZIP_CODE: 'Zip Code',
  REGION: 'Region',
  CONSTANT_OFFER: 'Constant offer',
  'a.m': 'am',
  'p.m': 'pm',
  Evening: 'Evening',
  AVAILABLE_DATES: 'Available Dates',
  VIEW_DATES: 'view available dates',
  NO_DATES: 'no dates available',
  TIME_SCHEDULE: 'Time Schedule',
  NO_TIME_SCHEDULE: 'No Time Schedule',
  'New Card': 'New Card',

  MY_ORDERS: 'My Orders',
  MY_OFFERS: 'My Offers',
  GO_TO_OFFERS: 'Go to My Offers',
  GO_TO_ORDERS: 'Go to My Orders',
  YOUR_OFFER: 'Your Offer',
  WAS_DELETED: 'was deleted by the admin',

  NOTIFICATIONS: 'Notifications',
  NEW_ORDER: 'New Order',
  ORDER_ACCEPTED_NOTIFICATION: 'Order Accepted',
  ORDER_REFUSED_NOTIFICATION: 'Order Refused',
  NEW_ORDER_NOTIFICATION_MESSAGE: 'You have new order request',
  OFFER_DELETED: 'Offer Deleted',
  OFFER_DELETED_NOTIFICATION_MESSAGE: 'Your offer was deleted by the Admin',
  Reason: 'Reason',
  SWITCH_ACCOUNT_MESSAGE: 'Please switch account to view this Order',

  //Modals
  ORDER_ACCEPTED: 'You have accepted the order!',
  Continue: 'Continue',
  ACCEPT: 'Accept',
  REPORT_REASON: 'Your reason has been sent to the guest.',
  'Write a reason of reporting': `Write a reason of reporting`,
  REFUSE_ORDER: 'Refuse Order',
  ACCEPTED_ORDER: 'Your order has been accepted!',
  PICKUP_ADDRESS: 'Pickup your order at the following address at',
  REFUSE_MESSAGE: 'Your order has been refused!',
  ORDER_SENT: 'Your order has been sent!',
  PROSSECCING_TO_COOK: 'Proccessing to the i offer',
  SET_VISIBLE: 'You are about to set this meal as invisible.',
  VISIBLE_MESSAGE: `That can be useful, if you know you will cook the meal later in future
  and don’t want to delete it.`,
  DONT_SHOW_AGAIN: `Don't show again`,
  LOGIN_MODAL: 'You need to create an account or login to order!',
  TAKE_A_MOMENT: 'It will only take a moment.',
  NO_CHAT_MESSAGE: 'You do not have any messages yet',
  OFFER_ORDER: 'Swap',
  ADD_OFFER: 'Add Offer',
  ADDRESS: 'Address',
  ADDRESS_NOTES: 'Note (floor, apartment number, etc.)',

  'Sending Order': 'Sending Order',
  'Logging in': 'Logging in',
  'accepted order': 'accepted order',
  REPORT_MESSAGE:
    'Thank you for your report. We will investigate it as soon as possible.',
  'Adding Report': 'Adding Report',
  CREATE_PROFILE: 'Create Profile',
  // BUTTONS
  SEND_ORDER: 'Send Order',
  NAVIGATE: 'Navigate',
  SKIP: 'Skip',
  SUBMIT: 'Submit',
  'Signing you up': 'Signing you up',
  'Creating profile': 'Creating profile',

  // AUTHENTICATION
  CREATE_AN_ACCOUNT: 'Create an Account',
  OR_SIGN_IN: 'Or Sign In With',
  EMAIL_LOGIN: 'E-mail Login',
  FACEBOOK_LOGIN: 'Facebook',
  GOOGLE_LOGIN: 'Google',
  LOGIN: 'Login',
  PASSWORD: 'Password',
  PASSWORD_AGAIN: 'Password Again',
  NAME: 'Firstname',
  SURNAME: 'Surname',
  CREATE_ACCOUNT: 'Create Account',
  CREATE: 'Create',
  I_AGREE_WITH: 'I agree with',
  TERMS_AND_CONDITIONS: 'Terms and Conditions',
  FORGOT_PASSWORD: 'Forgot Password',
  FORGOT_YOUR_PASSWORD: 'Forgot your password?',
  TO_RESET_PASSWORD: 'To reset your password please enter your e-mail below.',
  PASSWORD_SENT: 'Password has been sent to your e-mail.',
  ADMIN_LOGIN: 'Login as Admin',
  CREATE_COOK_ACCOUNT: 'Create “I offer” account',
  CREATE_GUEST_ACCOUNT: 'Create “I seek” account',
  COOKIES:
    'To improve our website and provide a personalised services to you, we would like to store cookies on your device.',
  READ_MORE: ' Read more.',
  IMAGE_NOTE: '*image should be have 400kb max size',

  //Welcome Screen
  GUEST_DESCRIPTION: 'I want to buy delicious meals from various cooks',
  COOK_DESCRIPTION: 'I want to sell my menu and cook it with love for guests',
  GUEST_BUY_DESCRIPTION: 'I want to seek',
  GUEST_SELL_DESCRIPTION: 'I want to offer',
  I_AM_GUEST: `I seek`,
  I_AM_COOK: `I offer`,

  //Date Picker Weekdays
  Mo: 'Mo',
  Tu: 'Tu',
  We: 'We',
  Th: 'Th',
  Fr: 'Fr',
  Sa: 'Sa',
  Su: 'Su',
  //Date Picker Months
  January: 'January',
  February: 'February',
  March: 'March',
  April: 'April',
  May: 'May',
  June: 'June',
  July: 'July',
  August: 'August',
  September: 'September',
  October: 'October',
  November: 'November',
  December: 'December',

  //restriction
  'Dairy Free': 'Dairy Free',
  'Gluten Free': 'Gluten Free',
  Halal: 'Halal',
  Kosher: 'Kosher',
  'Nut Free': 'Nut Free',
  Organic: 'Organic',
  Vegan: 'Vegan',
  Vegetarian: 'Vegetarian',
  'Low Carb': 'Low Carb',
  Fitness: 'Fitness',
  'Sugar Free': 'Sugar Free',
  Paleo: 'Paleo',
  GENERAL: 'General',

  //ERROR HANDLER
  INPUT_FIRST_NAME: 'Please input your First name!',
  INPUT_LAST_NAME: 'Please input your Last name!',
  INPUT_USERNAME: 'Please input your username!',
  INPUT_DESCRIPTION: 'Please input your description!',
  INPUT_PHONE_NUMBER: 'Please input your Phone Number!',
  INPUT_STREET: 'Please input Street!',
  INPUT_CITY: 'Please input City!',
  TIME_ERROR: 'Time must be greater than the current time.',
  CONSUMPTION_ERROR: 'Please select Consumption Type',
  DATE_ERROR: 'Please select Date and Time',
  IMAGE_UPLOAD_ERROR: 'Please upload an image',
  MEAL_NAME_ERROR: 'Please fill Meal name!',
  MEAL_DESCRIPTION_ERROR: 'Please fill Meal Description!',
  PRICE_ERROR: 'Please input Price',
  RESCTRICTED_MESSAGE: 'You have entered some restricted words.',

  // SUCCESS HANDLER
  'Profile Updated': 'Profile Updated',
  'Something went wrong': 'Something went wrong',
  //meal filter
  'Meal Filter': 'Meal Filter',
  Filter: 'Filter',
  LOCATION: 'Location',
  NEAREST: 'Nearest',
  FROM: 'From',
  TO: 'To',
  SET: 'Set',
  MAX_PRICE: 'Max price',

  //update profile
  EDIT_PROFILE_HEADER_COOK: 'Create Profile as i offer',
  EDIT_PROFILE_HEADER_GUEST: 'Create Profile as i seek',

  //Edit meal
  'Edit Offer': 'Edit Offer',
  'Editing Offer': 'Editing Offer',
  MAX_TIME: 'Max-time',
  //Edit meal error
  FILL_TITLE: 'Please fill Meal name!',
  FILL_DESCRIPTION: 'Please fill Meal Description!',
  FILL_PRICE: 'Please input Price',

  // PRODUCT CATEGORIES
  Handyman: 'Handyman',
  Services: 'Services',
  Crafts: 'Crafts',
  Tools: 'Tools',

  'Friuts and vegetables': 'Friuts and vegetables',
  'Pickles, jams, marmelades': 'Pickles, jams, marmelades',
  'Ready meals': 'Ready meals',
  Sweets: 'Sweets',
  'Bakery products and pastry': 'Bakery products and pastry',
  Herbs: 'Herbs',
  'Garden surpluses': 'Garden surpluses',

  'Cosmetics, beauty and health': 'Cosmetics, beauty and health',
  Elecrtonics: 'Elecrtonics',

  'Kitchen and accessories': 'Kitchen and accessories',
  Cooking: 'Cooking',
  'Bathroom and accessories': 'Bathroom and accessories',
  Furniture: 'Furniture',
  'Small furniture': 'Small furniture',
  Matraces: 'Matraces',
  Decorations: 'Decorations',
  'Home accessories': 'Home accessories',
  'Home textile': 'Home textile',
  'Pictures and frames': 'Pictures and frames',
  Mirrors: 'Mirrors',
  'Carpets and floorings': 'Carpets and floorings',
  Heaters: 'Heaters',
  Lights: 'Lights',
  Ventilators: 'Ventilators',
  'Collecting, antique, arts': 'Collecting, antique, arts',

  'Garden furniture': 'Garden furniture',
  Garden: 'Garden',
  Flowers: 'Flowers',
  Grilling: 'Grilling',
  'Dools and accessories': 'Dools and accessories',

  Clothes: 'Clothes',
  Shoes: 'Shoes',
  'Bags and luggages': 'Bags and luggages',

  'Childerns accessories': 'Childerns accessories',
  'Childrens furniture': 'Childrens furniture',
  'Childrens clothes': 'Childrens clothes',
  'Childrens shoes': 'Childrens shoes',
  Toy: 'Toy',
  'Books and textbooks': 'Books and textbooks',
  'Video games, films, CDs': 'Video games, films, CDs',
  'Music and musical instruments': 'Music and musical instruments',

  'Sport accessories': 'Sport accessories',
  'Sport clothes': 'Sport clothes',

  Cars: 'Cars',
  Motorbiking: 'Motorbiking',
  Cykling: 'Cykling',

  'For pets': 'For pets',
  Others: 'Others',

  // CARDS AND BANK DETAILS
  PAYMENT_CARD: 'Payment Card',
  NEW_CARD: 'New Card',
  BANK_ACCOUNT: 'Bank account',
  NEW_ACCOUNT: 'New Account',
  ACCOUNT_DETAILS: 'Account Details',

  CARD_DETAILS: 'Card Details',
  CARD_NUMBER: 'Card Number',
  CARDHOLDER_NAME: `Holder's Name`,
  IBAN: 'IBAN',
  ACCOUNT_NUMBER: 'Account Number',
  SWIFT_CODE: `SWIFT Code/ BIC`,
  BANK_NAME: 'Bank Name',
  BANK_ADDRESS: 'Bank Address',

  EMPTY_PAYMENT_CARDS: `You haven't added any cards.`,
  EMPTY_BANK_ACCOUNT: `You haven't added an account.`,
  DELETE_THIS_CARD: 'Do you really want to delete this card?',
  PAYMENT_THRESHOLD: 'Payment Threshold',
  PAYMENT_THRESHOLD_MESSAGE:
    'You will receive payment when the amount owed exceeds the specified threshold.',

  INVALID_CARD_NUMBER: 'Invalid card number',
  INVALID_CARD_EXPIRATION: 'Invalid card expiration date',
  INVALID_CVV: 'CVV card is invalid',

  INPUT_HOLDERS_NAME: `Please input Holder's Name!`,
  INPUT_ACCOUNT_NUMBER: `Please input Account Number!`,
  INPUT_IBAN: 'Please input IBAN!',
  INPUT_SWIFT_CODE: 'Please input SWIFT Code/BIC!',
  INPUT_BANK_NAME: 'Please input Bank Name!',
  INPUT_BANK_ADDRESS: 'Please input Bank Address!',
  INPUT_PAYMENT_THRESHOLD: 'Please input Payment Threshold!',

  //Change Password
  STAY_LOGGED: 'Stay logged in',
  CURRENT_PASSWORD: 'Current Password',
  NEW_PASSWORD: 'New Password',
  PASSWORD_INVALID: 'The current password is invalid.',
  PASSWORD_CHARACTERS: 'Password should be atleast 6 characters.',
};

export default translationEng;
